<div class="row" style="height: 100vh;">
  <div class="auth-page col-xs-12">
    <router-outlet class="animated infinite fadeIn delay-2s"></router-outlet>
  </div>
</div>
